export default "__VITE_ASSET__DiPNe1RE__"